import { Navigate } from 'react-router-dom'
// import { lazy } from "react";

// const Home = lazy(() => import('@src/views/home'));
// const Game = lazy(() => import('@src/views/game'));
// const Mission = lazy(() => import('@src/views/mission'));
// const CollectionsIndex = lazy(() => import('@src/views/collections'));
// const CollectionsMission = lazy(() => import('@src/views/collections/[id]'));

import CollectionsIndex from '@src/views/collections'
import CollectionsMission from '@src/views/collections/[id]'
import Game from '@src/views/game'
import Reset from '@src/views/game/reset'
import Home from '@src/views/home'
import Mission from '@src/views/mission'

export const protectedRoutes = [
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/game/:id',
    element: <Game />,
  },
  {
    path: '/game/:id/reset',
    element: <Reset />,
  },
  {
    path: '/mission/:id',
    element: <Mission />,
  },
  {
    path: '/collections/:id',
    element: <CollectionsMission />,
  },
  {
    path: '/collections',
    element: <CollectionsIndex />,
  },
  {
    path: '/*',
    element: <Navigate to="/home" replace />,
  },
]
